var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-layout',{staticClass:"goods",attrs:{"title":"待消耗门店","refresh":_vm.refresh,"back":_vm.back,"showBack":true}},[_c('div',[_c('a-table',{attrs:{"bordered":"","data-source":_vm.dataSource,"columns":_vm.columns}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }